<template>
    <div v-if="users?.length > 1" class="user-selector">
        <div v-for="user in users" :key="user.id" :data-tooltip="`${user.firstName} ${user.lastName}`">
            <div :class="userClass(user.id)" @click="emitEvent({ name: 'user-selected', payload: user.id })">
                <img v-if="user.photoAvatar" :src="user.photoAvatar" alt="" />
                <div v-else class="user-selector__user--initials">
                    {{ user?.firstName?.charAt(0) }}{{ user?.lastName?.charAt(0) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            users: { type: Array, required: true },
            selectedUserId: { type: Number, required: true },
        },

        methods: {
            userClass(userId) {
                return {
                    'user-selector__user': true,
                    'user-selector__user--selected': userId === this.selectedUserId,
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .user-selector {
        display: flex;
        position: relative;

        @include breakpoint(smartphone-large) {
            display: ruby;
        }

        &__user {
            height: 45px;
            width: 45px;
            border: 2px solid $color-light-blue-3;
            border-radius: 50%;
            margin: -6px;
            overflow: hidden;
            cursor: pointer;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.5s ease; /* Animation speed and effect */

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            &--initials {
                line-height: 38px;
                font-weight: 500;
                height: 42px;
                width: 42px;
                border: 1px solid $color--border-card;
                border-radius: 50%;
                background: $color--accent-3;
                color: white;
            }

            &--selected {
                z-index: $layer--base;
                border-color: $color-light-blue-2;
                transform: scale(1.1);
            }

            &:hover {
                z-index: $layer--above-parent;
                transform: scale(1.15);
            }
        }
        [data-tooltip]:hover::after {
            display: block;
            position: absolute;
            content: attr(data-tooltip);
            border: 1px solid $color-light-blue-2;
            background: $color-light-blue-3;
            opacity: 0.8;
            padding: 0.25em;
            border-radius: 8px;
            top: 50px;
            width: auto;
            z-index: $layer--above-parent;
            left: 50%;
            transform: translateX(-50%);
            min-width: 160px;
            text-align: center;
        }
    }

    .subdomain-layout--navy_black .category-info,
    .subdomain-layout--black .category-info {
        [data-tooltip]:hover::after {
            background: white;
            color: black;
            opacity: 1;
        }
    }
</style>
